import { Component } from '@angular/core';
import {PopupDialogComponent} from "./popup-dialog.component";
import {TableEditorComponent} from "../../controls/table-editor/table-editor.component";
import { Holiday } from "../../controls/leave-manager/leave-manager.component";
import {Globals} from "../../shared/Globals";
import {TreeNode} from "../../interfaces/treenode";
import {NbDialogRef} from "@nebular/theme";

@Component({
    templateUrl: './popup-dialog.component.html',
    styleUrls: ['./popup-dialog.component.scss'],
    standalone: false
})
export class LeaveDialogComponent extends PopupDialogComponent<TableEditorComponent<Holiday>>{

  protected ngOnInitComponent() {
    super.ngOnInitComponent();
    if(this.instance){
      this.instance.sorter = (a: TreeNode<Holiday>, b: TreeNode<Holiday>) => {
        if(a.data.dates && b.data.dates){
          return Globals.fromDateString(b.data.dates.end).getTime() - Globals.fromDateString(a.data.dates.end).getTime();
        }
        else if(a.data.end_on && b.data.end_on){
          return Globals.fromDateString(b.data.end_on).getTime() - Globals.fromDateString(a.data.end_on).getTime();
        }
        return 0;
      };
    }
  }

  protected component(): any {
    return TableEditorComponent;
  }

  done(result: any = null) {
    this.ref.close(this.instance.values || []);
  }
}
